export default __webpack_public_path__ + "static/media/img3.c582d7c1.png";